import "vditor/src/assets/less/index.less";
import { useEffect, useRef } from "react";
import Vditor from "vditor";
import { BASE_CDN_URL } from "./const";
import { hasUnpairedDoubleAsterisks } from "./util";
import "./index.less";

interface IMarkdownPreview {
  className?: string;
  value?: string;
  height?: number;
}

export default function MarkdownPreview(props: IMarkdownPreview) {
  const { className, value } = props;
  const vditorPreviewEle = useRef<HTMLDivElement>(null);

  function valueChange() {
    const hasUnpaired = hasUnpairedDoubleAsterisks(value || "");
    // 单独以-结尾的，会使标题字体变大，不进行预览
    // 有未闭合的**，不进行预览
    if (!value?.endsWith("-") && !hasUnpaired) {
      Vditor.preview(vditorPreviewEle.current as HTMLDivElement, value || "", {
        mode: "light",
        cdn: BASE_CDN_URL,
        theme: {
          current: "light",
          path: BASE_CDN_URL + "/dist/css/content-theme",
        },
      });
    }
  }

  useEffect(() => {
    valueChange();
  }, [value]);

  return (
    <div className={`${className} vditor select-text`}>
      <div ref={vditorPreviewEle} />
    </div>
  );
}
